// A list of PIDs of partners to consider when determining if SMS messages will be sent via Broadly 1.0.
// NOTE: This is a front-end indicator only, the backend will determine the actual sending method.
export const BROADLY_SMS_PIDS = [
  'NBLY',
  'PRBS',
  'CHOW', // Used in demo for testing Broadly SMS features
];

export const COUNTRIES_REQUIRING_REGISTRATION = ['us', 'it', 'au'];

export const COUNTRIES_REQUIRING_A2P_REGISTRATION = ['us'];

/**
 * Calculates countries that require regulatory compliance but not A2P registration.
 * This is the difference between countries requiring registration and those requiring A2P registration.
 * @returns Array of country codes requiring regulatory compliance (excluding A2P registration)
 */
export function getCountriesRequiringRegulatoryCompliance(): string[] {
  return COUNTRIES_REQUIRING_REGISTRATION.filter((country) => !COUNTRIES_REQUIRING_A2P_REGISTRATION.includes(country));
}
